import { render, staticRenderFns } from "./ToReceive.vue?vue&type=template&id=38a07868&scoped=true&"
import script from "./ToReceive.vue?vue&type=script&lang=js&"
export * from "./ToReceive.vue?vue&type=script&lang=js&"
import style0 from "./ToReceive.vue?vue&type=style&index=0&id=38a07868&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a07868",
  null
  
)

export default component.exports